import { v4 as uuid } from "uuid";
import {
  AccountIdentity,
  Conf2AccountFirstName,
  Conf2AccountId,
  Conf2AccountLastName,
  Conf2AccountType
} from "../../interface";
import { CONF2_ACCOUNT_TYPE } from "../../const";

export class Conf2AccountSpecs {
  private static SPECIAL_ACCOUNT_TYPES = [
    CONF2_ACCOUNT_TYPE.Host,
    CONF2_ACCOUNT_TYPE.Speaker
  ];

  static accountIdentityFactory(
    firstName: Conf2AccountFirstName,
    lastName?: null | Conf2AccountLastName
  ): AccountIdentity {
    if (!lastName?.length) {
      return firstName as unknown as AccountIdentity;
    }

    return [firstName, lastName].join(" ") as AccountIdentity;
  }

  static idFactory(): Conf2AccountId {
    return uuid() as Conf2AccountId;
  }

  static isHost(speakerType: Conf2AccountType) {
    return CONF2_ACCOUNT_TYPE.Host === speakerType;
  }

  static isSpecial(speakerType: Conf2AccountType) {
    return Conf2AccountSpecs.SPECIAL_ACCOUNT_TYPES.some(
      (_) => _ === speakerType
    );
  }

  static isRegular(speakerType: Conf2AccountType) {
    return CONF2_ACCOUNT_TYPE.Viewer === speakerType;
  }
}
